// src/components/ProductDetail/QtyControl.tsx

import { useState } from "react"

type Props = {
    max?: number
    value?: number
    onChange?: (value: number) => void
}

export default function QtyControl({
    max = 20,
    value = 0,
    onChange,
}: Props) {
    const [qty, setQty] = useState<number>(value)

    const update = (next: number) => {
        const safe = Math.max(0, Math.min(max, next))
        setQty(safe)
        onChange?.(safe)
    }

    return (
        <div className="styles_container__RJvSq qty-control-wrapper">

            {/* MINUS */}
            <div
                className="styles_minusContainer__61A8K qty-control-minus"
                role="button"
                onClick={() => update(qty - 1)}
            >
                <div className="styles_minus__BA244" />
            </div>

            {/* INPUT */}
            <div className="MuiInput-root MuiInputBase-root MuiInputBase-colorPrimary qty-control-input css-1f63zq5">
                <input
                    name="inputNumber"
                    type="number"
                    className="MuiInput-input MuiInputBase-input css-mnn31"
                    value={qty}
                    min={1}
                    max={max}
                    onChange={(e) => update(Number(e.target.value) || 1)}
                />
            </div>

            {/* PLUS */}
            <div
                className="styles_addContainer__07KXb qty-control-plus"
                role="button"
                onClick={() => update(qty + 1)}
            >
                <div className="styles_addIcon__SXVYV" />
            </div>

        </div>
    )
}
